import React from "react";

export default function ForbiddenTable() {
  return <div>NOT FOUND</div>;
}
